import { ROLES, type UserRole } from "../roles";
import { PERMISSIONS } from "./constants";
import { hasPermissionInList } from "./checks";
import { hasModuleAccess } from "./module-access";
import type { UserPermission } from "./types";

export type PreparedItemRequestAccount = {
  role?: UserRole;
  branchId?: string;
  branchName?: string;
} | null;

/** Branch roles (or a branch assignment) vs central kitchen roles. */
export function isBranchAccountUser(
  user?: PreparedItemRequestAccount,
): boolean {
  if (!user) {
    return false;
  }

  if (user.role === ROLES.CK_MANAGER || user.role === ROLES.CK_STAFF) {
    return false;
  }

  if (user.role === ROLES.BRANCH_MANAGER || user.role === ROLES.BRANCH_STAFF) {
    return true;
  }

  return Boolean(user.branchName);
}

export function hasCkPreparedItemView(
  userPermissions: readonly UserPermission[],
): boolean {
  return hasPermissionInList(
    userPermissions,
    PERMISSIONS.CK_REQUEST_PREPARED_ITEM_VIEW,
  );
}

export function canAccessCkPreparedItemRoutes(
  userPermissions: readonly UserPermission[],
  isBranchUser = false,
): boolean {
  return !isBranchUser && hasCkPreparedItemView(userPermissions);
}

export function canAccessRequestsSentRoutes(
  userPermissions: readonly UserPermission[],
  isBranchUser: boolean,
): boolean {
  return (
    isBranchUser &&
    hasModuleAccess(userPermissions, "branchRequestPreparedItem")
  );
}
